import * as actionTypes from "actions";
const userInitialState = {
  loading: false,
  patientData: [],
  error: "",
};

const patientDetailReducer = (state = userInitialState,  action) => {
  switch (action.type) {
    case actionTypes.FETCH_PATIENTDETAIL_BY_ID_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.FETCH_PATIENTDETAIL_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        patientData: action.payload,
        error: "",
      };
    case actionTypes.FETCH_PATIENTDETAIL_BY_ID_FAILURE:
      return {
        ...state,
        loading: false,
        patientData: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default patientDetailReducer;
